import axios from 'axios';
import {clarify} from "../utils/clear";

class SmsApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }

    getTemplateList(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/sms/templateList`, {params}).then(response => response.data);
    }

    saveTemplate(body){
        return axios.put(`${this.endpoint}/sms/saveTemplate`, body).then(response => response.data);
    }

    updateTemplate(body){
        return axios.put(`${this.endpoint}/sms/updateTemplate`, body).then(response => response.data);
    }

    deleteTemplate(body){
        return axios.put(`${this.endpoint}/sms/deleteTemplate`, body).then(response => response.data);
    }

    changeActivatedTemplate(id){
        return axios.put(`${this.endpoint}/sms/template/${id}/change/activated/`).then(response => response.data);
    }

    sendMessage(body){
        return axios.post(`${this.endpoint}/sms/send`, body).then(response => response.data);
    }

    getSmsHistoryList(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/sms/historyList`, {params}).then(response => response.data);
    }

    getSmsMessages(requestId){
        return axios.get(`${this.endpoint}/sms/messages/${requestId}`).then(response => response.data);
    }
    
}

export default new SmsApi();
